module.exports = __webpack_public_path__ + "static/communication-f8aaf2b02c570c1a7301d62772cd23e0.png";